module.exports = __webpack_public_path__ + "img/tarot-major-arcana-07.562d3bb6.png";